/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import $ from 'jquery'

class Reson extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reason: [],
      printInfo: [],
      lengthReson: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      modalEdit: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'عنوان',
          value: 'reason',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نوع',
          value: 'type',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'وضعیت فعال',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getAllReason = (exportStatus) => {
    let filter = this.createFilter(exportStatus)

    http
      .get(`${BASE_REPORT.BASE_REPORT_REASON}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable').fadeIn()

          if (!exportStatus) {
            this.setState({
              reason: response.data.object.result,
              lengthReson: response.data.object.countAll
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: response.data.object.result
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error));
      })
  }

  componentDidMount() {
    this.getAllReason(false)
  }

  activate = (numRow) => {
    let status = this.state.reason[numRow].enabled
    if (status) {
      let id = this.state.reason[numRow].reasonId
      let data = {
        id: id
      }
      const token = sessionStorage.getItem('accessToken')

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DISABLE_REASON}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllReason(false)
          } else {
            message.error('عملیات تغییر وضعیت دلیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let id = this.state.reason[numRow].reasonId
      let data = {
        id: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ENABLE_REASON}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllReason(false)
          } else {
            message.error('عملیات تغییر وضعیت دلیل موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteReason = (numId) => {
    let resonId = this.state.reason[numId].id
    let reasonName = this.state.reason[numId].reason
    sessionStorage.setItem('reasonId', resonId)
    sessionStorage.setItem('reasonName', reasonName)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('reasonId')
    sessionStorage.removeItem('reasonName')
  }

  deleteOk = () => {
    let reasonId = sessionStorage.getItem('reasonId')
    let data = {
      id: reasonId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_DELETE_REASON}`, data, {})
      .then((response) => {
        if (response.data.error == null && response.data.object == 'SUCCESS') {
          this.getAllReason()
          message.success('دلیل با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description))
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  editReason = (numId) => {
    let resonId = this.state.reason[numId].id
    let reasonName = this.state.reason[numId].reason
    let typeName = this.state.reason[numId].type
    sessionStorage.setItem('resonId', resonId)
    sessionStorage.setItem('reasonName', reasonName)
    sessionStorage.setItem('typeName', typeName)
    this.setState({
      modalEdit: !this.state.modalEdit
    })
  }

  EditCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit
    })
    sessionStorage.removeItem('resonId')
    sessionStorage.removeItem('reasonName')
    sessionStorage.removeItem('typeName')
  }

  EditOk = () => {
    let resonId = sessionStorage.getItem('resonId')

    var name = document.getElementById('name').value
    var type = document.getElementById('type').value
    var nameError = false
    var typeError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام دلیل وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      typeError = true
      message.error('نوع دلیل را وارد کنید')
    } else {
      if (!typeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        reasonId: resonId,
        name: name,
        type: type
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_EDIT_REASON}`, data)
        .then((response) => {
          if (response.data.error == null) {
            this.getAllReason()
            message.success('دلیل ویرایش شد')
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllReason(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllReason(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllReason(false)
    }
  }
  createFilter = (exportStatus) => {
    let filter = {}

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    return filter
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${BASE_REPORT.BASE_REPORT_REASON}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }

            if (excelReport[i]['type'] == '11') {
              excelReport[i]['type'] = 'مرجوعی'
            } else {
              excelReport[i]['type'] = ''
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.getAllReason(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {pageNumber, pageSize} = this.state
    // let excelColumns = [
    //   { title: "عنوان", value: "reason" },
    //   { title: "نوع", value: "type" }
    // ];

    let reasonName = sessionStorage.getItem('reasonName')
    let typeName = sessionStorage.getItem('typeName')
    let name = cookie.load('name')
    let columns = ['ردیف', 'عنوان', 'نوع ', 'وضعیت فعال']
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست دلایل"
              headerColSpan={4}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((reason, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{reason.reason}</td>
                  <td>{reason.type == '11' ? 'مرجوعی' : ''}</td>
                  <td>{reason.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="لیست دلایل ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'reason'}
                field={'reason'}
                title={'نام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'type'}
                field={'type'}
                title={'نوع'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>لیسست دلایل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/addReson'} enablePageSize />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />

                {this.state.reason.map((reason, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{reason.reason}</td>
                    <td>{reason.type == '11' ? 'مرجوعی' : ''}</td>
                    <td>
                      <button onClick={() => this.activate(index)}>
                        {reason.enabled ? (
                          <img src={require('../../image/on.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/off.svg')} alt="" />
                        )}
                      </button>
                    </td>
                    <td>
                      <button onClick={() => this.editReason(index)}>
                        <img src={require('../../image/editDriver.svg')} alt="" />
                      </button>
                    </td>
                    <td>
                      <button onClick={() => this.deleteReason(index)}>
                        <img src={require('../../image/trash.svg')} alt="" />
                      </button>
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={pageSize}
                  currentPage={pageNumber}
                  total={this.state.lengthReson}
                />
              </div>
            </div>
          </div>

          <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
            <ModalHeader toggle={this.deleteCancel}>حذف دلیل</ModalHeader>
            <ModalBody>
              <p className="titleSm">آیا از حذف دلیل {reasonName} مطمئن هستید؟؟؟</p>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.deleteOk}>
                حذف دلیل
              </button>
              <button className="cancelBtnModal" onClick={this.deleteCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalEdit} toggle={this.EditCancel} size="sm">
            <ModalHeader toggle={this.EditCancel}>ویرایش {reasonName}</ModalHeader>
            <ModalBody>
              <div className="formComponent">
                <label>نام دلیل (الزامی)</label>
                <input type="text" defaultValue={reasonName} id="name" className="form-control" />
              </div>

              <div className="formComponent">
                <label>نوع (الزامی)</label>
                <select className="form-control" name="type" defaultValue={typeName} id="type">
                  <option value="">نوع را مشخص کنید</option>
                  <option value="11" selected={true}>
                    مرجوعی
                  </option>
                </select>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.EditOk}>
                ویرایش دلیل
              </button>
              <button className="cancelBtnModal" onClick={this.EditCancel}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Reson
